import {IStaffScheduleRepository} from "@/repository/workers/StaffScheduleRepository.types";
import Api from "@/repository/api";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import qs from "qs";
import { IStaffSchedule, IStaffScheduleListItem } from "@/entity/staff/schedule.types";
import StaffSchedule from "@/entity/staff/schedule";
import { StaffScheduleAddRequestType } from "@/form/staff/schedule/add.types";
import { StaffScheduleUpdateRequestType } from "@/form/staff/schedule/update.types";
import { ResponseDataType } from "@/form/form.types";

export default class StaffScheduleRepository implements IStaffScheduleRepository {
    async fetchAll(data?: PaginationRequestType): Promise<IStaffSchedule> {
        const response = await Api.get(`/staff/schedule/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const responseData = response.data as IStaffSchedule;
        return new StaffSchedule(responseData);
    }
    async create(data: StaffScheduleAddRequestType): Promise<ResponseDataType> {
        const res = await Api.post('/staff/schedule/create', data);
        return res.data;
    }
    async update(data: StaffScheduleUpdateRequestType): Promise<ResponseDataType> {
        const res = await Api.post('/staff/schedule/update', data);
        return res.data;
    }
    async delete(data: {id: number}): Promise<ResponseDataType> {
        const res = await Api.post('/staff/schedule/delete', data);
        return res.data;
    }
}
